// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ContextMenu_toggleButton__WgELD","menuItem":"ContextMenu_menuItem__2IJIk","menuItemIcon":"ContextMenu_menuItemIcon__22Pwb"};